import { fetchApi } from '@/utils/axios'
import { EnterpriseMfaConfig, UserMfaConfig, SaveUserMfaConfigParams,
  VerifyTotpCodeParams, GetCodeParams, VerifySmsCodeParams
 } from './types'

/** 查询企业MFA配置 */
export const queryEnterpriseMfaConfig = () => {
  return fetchApi<EnterpriseMfaConfig>({
    url: '/enterprises/mfa_config',
    method: 'GET',
    temporaryToken: true // 临时token
  })
}

/** 查询用户MFA配置 */
export const queryUserMfaConfig = () => {
  return fetchApi<UserMfaConfig>({
    url: '/users/mfa_config',
    method: 'GET',
    temporaryToken: true // 临时token
  })
}

/**
 * 保存用户MFA配置
 * @param {*} params
 * @param {string} params.type 类型，'TOTP'、'MOBILE'或'EMAIL'
 * @param {string} params.mobile 手机号码
 * @param {string} params.email 邮箱地址
 * @returns
 */
export const saveUserMfaConfig = (params: SaveUserMfaConfigParams) => {
  return fetchApi<UserMfaConfig>({
    url: '/users/mfa_config',
    method: 'POST',
    data: params,
    temporaryToken: true
  })
}

/**
 * 获取TOTP绑定URL(用以生成供扫描的二维码)
 * @returns {string} TOTP绑定URL
 */
export const getTotpBindUrl = () => {
  return fetchApi<string>({
    url: '/users/mfa_config/totp_auth_url',
    method: 'GET',
    temporaryToken: true
  })
}

/**
 * 验证TOTP授权码
 * @param {*} params
 * @param {string} params.code 授权码
 * @param {string} params.deviceFingerprint 设备指纹
 * @returns {boolean}
 */
export const verifyTotpAuthCode = (params: VerifyTotpCodeParams) => {
  return fetchApi({
    url: '/users/mfa_config/totp_auth_check',
    method: 'POST',
    data: params,
    temporaryToken: true
  })
}

/**
 * 获取验证码（手机或邮箱）
 * @param {*} params
 * @param {string} params.type 验证码类型，'MOBILE'或'EMAIL'
 * @param {string} params.mobile 手机号码
 * @param {string} params.email 邮箱地址
 * @returns {boolean}
 */
export const getCode = (params: GetCodeParams) => {
  return fetchApi({
    url: '/users/mfa_config/captcha',
    method: 'POST',
    data: params,
    temporaryToken: true
  })
}

/**
 * 验证验证码（手机或邮箱）
 * @param {*} params
 * @param {string} params.type 验证码类型，'MOBILE'或'EMAIL'
 * @param {string} params.mobile 手机号码
 * @param {string} params.email 邮箱地址
 * @param {string} params.code 验证码
 * @param {string} params.deviceFingerprint 设备指纹
 * @returns {boolean}
 */
export const verifyCode = (params: VerifySmsCodeParams) => {
  return fetchApi({
    url: '/users/mfa_config/captcha_check',
    method: 'POST',
    data: params,
    temporaryToken: true
  })
}
